import { render, staticRenderFns } from "./DerivedParamList.vue?vue&type=template&id=70e13558"
import script from "./DerivedParamList.vue?vue&type=script&lang=js"
export * from "./DerivedParamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports